/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { humanize } from "uno-js";
import { toast } from "react-hot-toast";
import { UPDATE_ASSESSMENT } from "../pages/CroApplicationDetails/graphql/updateAssessment.mutation";
import { string } from "yup";

const MODULE_NAME = "UpdateAssessmentService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class UpdateAssessmentService {
    private static instance: UpdateAssessmentService;
    private vapp: VApplication;
    private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.termsURL = props?.termsURL;
    }
    public static getInstance(props: any = {}): UpdateAssessmentService {
        if (!UpdateAssessmentService.instance) {
            UpdateAssessmentService.instance = new UpdateAssessmentService(
                props
            );
        }
        return UpdateAssessmentService.instance;
    }

    async updateAssessment(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `Update Assessment data in service`, data);
        // const assessmentDetail = {
        //     applicationId: "1653907533304",
        //     comments: "Application record has been verified",
        //     criminalRecords: [
        //         {
        //             offenseCommitted: "drunk and drive",
        //             courtName: "MC",
        //             sentense: "fined 1000",
        //             date: "20/05/2022",
        //             recordCopyURL: "",
        //         },
        //     ],
        // };
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: UPDATE_ASSESSMENT,
                    variables: { input:{...data}
                    },
                    fetchPolicy: "no-cache",
                });
                log.success(
                    MODULE_NAME,
                    "Update payment Receipt result : ",
                    res
                );
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }
}
